// extracted by mini-css-extract-plugin
module.exports = {"variables":"\"../../../../../../assets/stylesheets/variables.scss\"","midnightColor":"#201C1C","content":"AddObjectCombination_content__3lzxH"};